// src/CalendarStartIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var CalendarStartIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "23",
    height: "22",
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M20.5317 8.85197L21.1303 18.8866C21.1506 19.1606 21.0187 19.3432 20.9476 19.4244C20.8665 19.5157 20.694 19.6577 20.4099 19.6577H17.64L19.8316 8.85197H20.5317ZM21.6477 4.94566L21.6376 4.96595C21.6579 5.20946 21.6376 5.46312 21.5767 5.71678L14.0989 19.4447C13.8554 20.4694 12.9422 21.1797 11.887 21.1797H20.4099C21.7188 21.1797 22.7537 20.0737 22.6522 18.7649L21.6477 4.94566Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10.9434 1.13007C11.0449 0.724214 10.7912 0.308217 10.3854 0.206755C9.97952 0.115438 9.56352 0.358949 9.46206 0.764799L8.95474 2.86508H10.5173L10.9434 1.13007Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.64 1.10077C17.7313 0.684776 17.4675 0.289072 17.0515 0.197755C16.6456 0.106439 16.2398 0.370242 16.1485 0.786239L15.6919 2.88652H17.2544L17.64 1.10077Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M21.4651 4.2653C21.1303 3.4536 20.3389 2.87527 19.3648 2.87527H17.2544L16.6862 5.50315C16.605 5.85827 16.2905 6.10178 15.9455 6.10178C15.8948 6.10178 15.8339 6.10178 15.7832 6.08149C15.3773 5.99017 15.1135 5.58432 15.1947 5.17847L15.6919 2.86512L10.5173 2.86508L9.87806 5.50315C9.79689 5.84812 9.48236 6.08149 9.13739 6.08149C9.07651 6.08149 9.01563 6.07134 8.95475 6.06119C8.5489 5.95973 8.29524 5.55388 8.39671 5.13788L8.94461 2.85497H6.88491C5.89058 2.85497 5.00785 3.50433 4.71361 4.45808L0.442034 18.2063C-0.00440189 19.6775 1.08125 21.1791 2.61334 21.1791H15.9455C17.0007 21.1791 17.9139 20.4689 18.1574 19.4441L21.5767 5.71678C21.6376 5.46312 21.6579 5.20946 21.6376 4.96595C21.6173 4.72244 21.5666 4.47838 21.4651 4.2653ZM14.241 15.8523H6.12394C5.70795 15.8523 5.36297 15.5074 5.36297 15.0914C5.36297 14.6754 5.70795 14.3304 6.12394 14.3304H14.241C14.657 14.3304 15.0019 14.6754 15.0019 15.0914C15.0019 15.5074 14.657 15.8523 14.241 15.8523ZM15.2556 11.7938H7.13857C6.72257 11.7938 6.3776 11.4489 6.3776 11.0329C6.3776 10.6169 6.72257 10.2719 7.13857 10.2719H15.2556C15.6716 10.2719 16.0166 10.6169 16.0166 11.0329C16.0166 11.4489 15.6716 11.7938 15.2556 11.7938Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
var CalendarStartIcon_default = CalendarStartIcon;

export {
  CalendarStartIcon_default
};
